<template>
    <transition appear name="core-file-select-transition">
        <div class="core-file-select__base">
            <div class="overlay" @click="$emit('close')"></div>
            <div class="core-file-select">
                <h1 style="padding: 16px 20px 10px;background: #f5f5f5;">Files <v-icon @click="$emit('close')" color="green" style="float: right;margin-top: 10px;">check</v-icon></h1>
                <div class="files-container">
                    <div class="file-container" v-for="file in files" :key="file.object_id">
                        <div @click="fileSelected(file)" class="file">
                            <div v-if="file.content_type && file.content_type.match('image.*')" style="height: 100%;background-size: cover;background-position: center;background-repeat: no-repeat;" :style="{'background-image': `url(${file.file})`}"></div>
                            <div class="file-preview" v-else>
                                <span>{{ file.file && file.file.split(/[#?]/)[0].split('.').pop().trim() }}</span>
                            </div>
                            <div class="description">
                                <p>{{ file.name }}</p>
                                <p>{{ file.created_at.split('T')[0] }}</p>
                            </div>
                            <checkbox style="position: absolute;right: 16px;top: 16px;" :value="value.find(f => f.object_id === file.object_id) ? true : false" />
                        </div>
                    </div>
                    <div class="file-container">
                        <div class="file button" @click="$refs['image'] && $refs['image'].click()">
                            <p>Upload</p>
                        </div>
                    </div>
                    <div class="file-container" v-if="hasNext">
                        <div @click="getFiles" class="file button">
                            Load More...
                        </div>
                    </div>
                </div>
            </div>
            <input
                type="file"
                style="display: none"
                ref="image"
                accept="image/*,application/pdf"
                multiple="multiple"
                @change="onFilePicked"
            >
        </div>
    </transition>
</template>

<script>
import { files } from '@/api'
import _ from 'lodash'

export default {
    props: {
        value: {
            type: Array,
            default: () => []
        }
    }, 
    data() {
        return {
            files: [],
            next: null,
            hasNext: false
        }
    },
    async mounted() {
        this.getFiles()
    },
    methods: {
        onFilePicked (e) {
            let file = e.target.files[0]
            if (file) {
                var formData = new FormData()
                formData.append('file', file)
                files.create(formData).then(response => {
                    this.files.push(response.data)
                })
            }
		},
        fileSelected(file) {
            let fs = _.cloneDeep(this.value)
            let index = fs.findIndex(f => f.object_id === file.object_id)
            if (index > -1) {
                fs.splice(index, 1)
                this.$emit('input', fs)
            } else {
                fs.push(_.cloneDeep(file))
                this.$emit('input', fs)
            }
        },
        getFiles() {
            this.$store.dispatch('load', files.get(this.next).then((response) => {
                this.files = [...this.files, ...response.data.results]
                this.hasNext = response.data.next ? true : false
                this.next = response.data.next
            }))
        }
    }
}
</script>

<style scoped>
.core-file-select__base {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    padding: 12px;
    z-index: 1000;
}

.core-file-select-transition-enter-active, .core-file-select-transition-leave-active {
    transition: all .3s;
}

.core-file-select-transition-enter .overlay, .core-file-select-transition-leave-to .overlay {
    opacity: 0;
}

.core-file-select-transition-enter-to .overlay, .core-file-select-transition-leave .overlay {
    opacity: 1;
}

.core-file-select-transition-enter .core-file-select, .core-file-select-transition-leave-to .core-file-select {
    transform: translate(-50%, calc(-50% + 30px)) !important;
    opacity: 0;
}

.core-file-select-transition-enter-to .core-file-select, .core-file-select-transition-leave .core-file-select {
    transform: translate(-50%, -50%);
    opacity: 1;
}

.core-file-select__base .overlay {
    background: rgba(33,33,33,0.46);
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    transition: opacity .3s;
}

.core-file-select__base .overlay:hover {
    cursor: pointer;
}

.core-file-select__base .core-file-select {
    background: white;

    position: absolute;
    left: 50%;
    top: 50%;
    transition: transform .3s, opacity .3s;
    transform: translate(-50%, -50%);
    
    box-shadow: 0 11px 15px -7px rgba(0,0,0,0.2), 0 24px 38px 3px rgba(0,0,0,0.14), 0 9px 46px 8px rgba(0,0,0,0.12);
    border-radius: 2px;
    max-height: 500px;
    max-width: 800px;
    width: 85%;
    display: flex;
    flex-flow: column;

    overflow: hidden;
}

.core-file-select__base .files-container {
    padding: 20px;
    overflow-y: auto;
    flex: 1;
}

.core-file-select .file-container {
    width: 33.1333%;
    display: inline-block;
    vertical-align: top;
}

.core-file-select .file {
    border: 1px solid #ECEEF4;
    margin: 8px;
    height: 150px;
    position: relative;

    overflow: hidden;
    border: 1px solid lightgrey;
}

.core-file-select .file .description {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;

    padding: 12px;
    padding-top: 20px;

    background-image: linear-gradient(to top,rgba(0,0,0,.65) 0,rgba(0,0,0,.5525) 55%,rgba(0,0,0,.195) 85%,rgba(0,0,0,0) 100%);
}

.core-file-select .file .description p {
    font-size: 13px;
    color: white;
}

.core-file-select .file .description p:not(:last-child) {
    margin-bottom: 4px;
}



.core-file-select .file:hover {
    cursor: pointer;
}

.core-file-select .file.button {
    display: flex;
    align-items: center;
    justify-content: center;
}

.core-file-select .file.button p {
    font-weight: bold;
    font-size: 20px;
}

.core-file-select .file p {
    margin-bottom: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 12px;
}

@media screen and (max-width: 512px) {
    .core-file-select {
        width: 90%;
    }
    .core-file-select .file-container {
        width: 50%;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/CoreFileSelect.vue